/**
 * @file コンポーネント：フル動画ページお気に入りボタン スタイル管理
 */

// ライブラリ読み込み
import styled from "styled-components";

// スタイル
export const StyledButton = styled.button`
    padding: 0;
    border: none;
    background-color: transparent;
    color: #929496;
    font-size: 20px;
    line-height: 20px;
`;
